import { Helmet } from "react-helmet-async"
import {
	MailboxInboxTab,
	TMailIntegration,
} from "../../../../../../Integrations"
import { useOutletContext } from "react-router"
import { useParams } from "../../../../../../router-utils"

export default function MailIntegrationFolderPage() {
	const context = useOutletContext<{ integration: TMailIntegration }>()
	const { folder } = useParams("/integrations/:integrationId/mail/:folder")

	if (folder === "inbox") {
		return (
			<>
				<Helmet>
					<title>Inbox | Integration</title>
				</Helmet>
				<MailboxInboxTab integration={context.integration} />
			</>
		)
	}

	return (
		<>
			<Helmet>
				<title>{folder} | Integration</title>
			</Helmet>
			<p>{folder} folder coming soon...</p>
		</>
	)
}
